import { useState, useEffect } from "react";

export const useIsResTecnico = (user) => {
  const [resTecnico, setResTecnico] = useState(false);

  useEffect(() => {
    const checkResTecnicoRole = async () => {
      if (user) {
        try {
          const idTokenResult = await user.getIdTokenResult(true);
          setResTecnico(idTokenResult.claims.resTecnico === true);
        } catch (error) {
          console.error(
            "Errore durante il controllo del ruolo resTecnico:",
            error
          );
          setResTecnico(false);
        }
      } else {
        setResTecnico(false);
      }
    };

    checkResTecnicoRole();
  }, [user]);

  return resTecnico;
};
